import { joinPath } from '../../core/utils';
import type { ModelSubscriptionOtherPaths } from './types';

/** 白名单与请求/速率限速表单路径 */
export function resolveModelSubscriptionOtherPaths(prefix: string): ModelSubscriptionOtherPaths {
  return {
    allowedClientCIDRs: joinPath(prefix, 'allowedClientCIDRs'),
    allowedClientIPs: joinPath(prefix, 'allowedClientIPs'),
    requests: joinPath(prefix, 'requests'),
    inputTokensValue: joinPath(prefix, 'inputTokensValue'),
    inputTokensWindowSeconds: joinPath(prefix, 'inputTokensWindowSeconds'),
    outputTokensValue: joinPath(prefix, 'outputTokensValue'),
    outputTokensWindowSeconds: joinPath(prefix, 'outputTokensWindowSeconds'),
    showRequests: joinPath(prefix, 'switches.showRequests'),
    showInputTokens: joinPath(prefix, 'switches.showInputTokens'),
    showOutputTokens: joinPath(prefix, 'switches.showOutputTokens'),
  };
}
